var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-detailed-tasks-list',{attrs:{"height":"auto","tasks":_vm.tasks,"value":_vm.dependencies},on:{"value-changed":_vm.handleDependencyChange}})}
var staticRenderFns = []

export { render, staticRenderFns }